import { useFocusEffect, useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';

import { selectIsLogged } from '../../store/auth/authReducer';
import { duelsRewardsRequest } from '../../store/duels/duelsActions';
import {
	selectDuelRewards,
	selectDuelRewardsErrorKey,
	selectDuelRewardsLoaded,
} from '../../store/duels/duelsReducer';
import { DuelRedemptionRow, redemptionHistory } from '../Components/Duels/DuelRewardsPanel';
import { duelText } from '../Components/Duels/duelsText';
import { DuelLoading, DuelNotice, DuelsPage } from '../Components/Duels/DuelsUi';
import { RootStackParamList } from '../navigator';

type NavType = NativeStackNavigationProp<RootStackParamList>;

const DuelRedemptionHistoryScreen = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const navigation = useNavigation<NavType>();
	const isLogged = useSelector(selectIsLogged);
	const loaded = useSelector(selectDuelRewardsLoaded);
	const errorKey = useSelector(selectDuelRewardsErrorKey);
	const history = redemptionHistory(useSelector(selectDuelRewards));

	useFocusEffect(
		useCallback(() => {
			if (isLogged) dispatch(duelsRewardsRequest());
		}, [dispatch, isLogged]),
	);

	return (
		<DuelsPage
			title={duelText(t, 'T_SITE_DUELS_PAGE_REDEMPTION_HISTORY')}
			onBack={() => navigation.goBack()}
		>
			{({ width, scale }) => {
				if (!loaded) {
					return errorKey ? (
						<DuelNotice
							scale={scale}
							width={width}
							text={duelText(t, errorKey)}
							actionLabel={duelText(t, 'T_SITE_DUELS_RETRY')}
							onAction={() => dispatch(duelsRewardsRequest())}
						/>
					) : (
						<DuelLoading />
					);
				}
				if (!history.length) {
					return (
						<DuelNotice
							scale={scale}
							width={width}
							text={duelText(t, 'T_SITE_DUELS_REWARDS_EMPTY')}
						/>
					);
				}
				return (
					<View style={{ width, rowGap: 8 * scale }}>
						{history.map(reward => (
							<DuelRedemptionRow
								key={reward.id}
								reward={reward}
								onPress={() => navigation.navigate('DuelReward', { entitlementId: reward.id })}
								scale={scale}
								withDate
							/>
						))}
					</View>
				);
			}}
		</DuelsPage>
	);
};

export default DuelRedemptionHistoryScreen;
